<template>
  <div>
    <el-dialog 
      :title="noticeTitle" 
      class="title-dialog" 
      v-model="dialogVisible" 
      @update:model-value="handleDialogVisibleChange"
      :append-to-body="true"
    >
      <el-divider class="title-headerDivider"></el-divider>
      <div class="form">
        <span v-html="noticeContent"></span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EjectAnnouncement",
  props: {
    centerDialogVisible: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      noticeContent: "",
      noticeTitle: "",
    };
  },
  methods: {
    handleDialogVisibleChange(value) {
      this.dialogVisible = value;
      if (!value) {
        this.$emit("setAnnouncementFlag", false);
      }
    },
  },
  watch: {
    centerDialogVisible(newVal) {
      const uiAnnoucementSettings = this.$objBaseInfo.uiAnnoucementSettings;
      if(this.$i18n.locale == "en"){
        this.noticeContent = this.$objBaseInfo.announcementNotice
          ? this.$objBaseInfo.announcementNotice[this.$i18n.locale]
          : uiAnnoucementSettings[0].notice[this.$i18n.locale];
        this.noticeTitle = uiAnnoucementSettings[0].title[this.$i18n.locale];
      } else {
        this.noticeContent = this.$objBaseInfo.announcementNotice
          ? this.$objBaseInfo.announcementNotice["zh-CN"]
          : uiAnnoucementSettings[0].notice["zh-CN"];
        this.noticeTitle = uiAnnoucementSettings[0].title["zh-CN"];
      }
      this.dialogVisible = newVal;
    },
  },
};
</script>

<style lang="stylus" scoped>
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: $btn-bg-color;
  border-top: none!important;
}

.form span {
  font-weight: 600;
  white-space: pre-wrap;
}
</style>
<style lang="stylus">
.title-dialog .el-dialog__title {
  font-weight: 600;
}
</style>